"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextThread = exports.Thread = exports.DEFAULT_SUBJECT = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const Contact_1 = require("./Contact");
const index_1 = require("../index");
exports.DEFAULT_SUBJECT = 'New Message/Thread';
class Thread extends Base_1.Base {
    third_party = '';
    gmail_id = '';
    subject = '';
    summary = '';
    inbound = false;
    html = ''; // deprecate/move to msgs
    type = '';
    medium = index_1.EMedium.NONE;
    template_id = ''; // deprecate/move to msgs
    url = '';
    creator = {};
    contact = null;
    object = null;
    recipients = [];
    filters = [];
    activity = [];
    follower_ids = [];
    ref = null;
    contactRef = null;
    metadata = {};
    agents = [];
    followers = [];
    roles = [];
    _html;
    _message;
    _unread;
    _modal;
    _m = ['date', 'creator', 'medium', 'subject', 'summary'];
    _s = ['name', 'filters', 'activity', 'medium', 'unread', 'inbound', 'active', 'cc', 'object', 'html', 'recipients', 'contact', 'creator', 'subject', 'summary', 'unassigned'];
    get unassigned() {
        return !!(!this.agents?.length && !this.followers?.length && !this.roles?.length);
    }
    get name() {
        return this.object?.toString() || '';
    }
    constructor(data, olMap, type, idLen) {
        super(type || 'threads', idLen || 24);
        (0, Common_1.setObjectProperties)(this, data, olMap, Thread);
        if (this.object) {
            this.object = (0, index_1.loadObject)(this.object, { olm: olMap });
            if (this.object && this.contact?._docRef) {
                this.contact = (0, index_1.loadObject)(this.contact, { olm: olMap });
                if (this.object && this.contact && !(this.object instanceof Contact_1.Contact)) {
                    this.object.contact = this.contact;
                }
            }
        }
    }
    toString() {
        return `Thread: ${this.medium}: ${this.subject || this.summary}`;
    }
    async markRead() {
        if (this.id && this._unread) {
            this._unread.seen = true;
            this._unread.last_date = Date.now();
            if (this._unread._exists) {
                await this._unread.save();
            }
        }
    }
    async loadAll(opts, stack, p) {
        await super.loadAll(opts, stack, p);
        if (this.ref?.get && !this.object?._docRef && opts.olm) {
            try {
                this.object = (0, index_1.loadObject)((await this.ref.get()), { olm: opts.olm });
            }
            catch (e) {
                console.warn(e.toString(), this.ref?.path);
            }
        }
        if (this.contactRef?.get && !this.contact?._docRef && opts.olm) {
            try {
                this.contact = (0, index_1.loadObject)((await this.contactRef.get()), { olm: opts.olm });
            }
            catch (e) {
                console.warn(e.toString(), this.contactRef?.path);
            }
        }
    }
    async save(parent) {
        if (this.object?._docRef) {
            this.ref = this.object?._docRef;
        }
        if (this.contact?._docRef) {
            this.contactRef = this.contact._docRef;
        }
        if (!this.ref && !(this instanceof index_1.ThreadMessage)) {
            throw `Cannot Save! No reference set on ${this._type?.replace(/s$/, '')}.`;
        }
        if (this.gmail_id) {
            this.third_party = this.gmail_id;
        }
        await super.save(parent);
    }
    toJSON() {
        let r = super.toJSON();
        r.follower_ids = (r.followers?.length && r.followers?.map) ? r.followers.map(f => f.id) : [];
        if (r.agents?.length && r.agents?.map) {
            r.follower_ids = r.follower_ids.concat(r.agents.map(f => f.id));
        }
        r.filters = (0, index_1.toMinJSON)(this, 'filters', true);
        r.unassigned = this.unassigned;
        if (this.object?._docRef) {
            r.ref = this.object._docRef;
        }
        if (this.contact?._docRef) {
            r.contactRef = this.contact._docRef;
        }
        return r;
    }
}
exports.Thread = Thread;
index_1.olm.threads = (ref, map) => {
    return new Thread(ref, map);
};
class TextThread extends Base_1.Base {
    threadRef = null;
    contactRef = null;
    contactPhone = '';
    twilioPhone = '';
    constructor(data, olMap) {
        super('_sms', null);
        (0, Common_1.setObjectProperties)(this, data, olMap, TextThread);
    }
    async save(parent) {
        this.id = `${this.contactPhone}-${this.twilioPhone}`;
        this._docRef = parent.doc(`${this._type}/${this.id}`);
        return super.save();
    }
}
exports.TextThread = TextThread;
index_1.olm._sms = (ref, map) => {
    return new TextThread(ref, map);
};
